export default "__VITE_ASSET__e_uvpMr3__"